import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-14d5d684")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", {
    id: "filterPanelContainer",
    style: _ctx.toolbarDescriptor.style.leftToolbarContainer
  }, [
    _createVNode("div", {
      id: "leftaxis",
      ref: "filterPanelContainer",
      class: "p-d-flex p-flex-column p-ai-center",
      style: _ctx.toolbarDescriptor.style.topAxis,
      onDrop: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onDrop($event))),
      onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
      onDragenter: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.displayDropzone && _ctx.displayDropzone(...args)))
    }, [
      (_ctx.showScroll)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            icon: "fas fa-arrow-circle-up",
            class: "p-button-text p-button-rounded p-button-plain p-mb-1",
            style: _ctx.toolbarDescriptor.style.whiteColor,
            onClick: _ctx.scrollUp
          }, null, 8, ["style", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode("div", {
        ref: "filterItemsContainer",
        class: "p-d-flex p-flex-column p-ai-center kn-flex",
        style: _ctx.toolbarDescriptor.style.scroll,
        onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
        onDragenter: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
        onDragleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideDropzone && _ctx.hideDropzone(...args)))
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: "p-d-flex p-flex-column p-ai-center"
          }, [
            _createVNode("div", {
              id: 'left-' + row.name,
              ref: 'left-' + row.name,
              class: "p-d-flex p-flex-column p-ai-center",
              style: _ctx.toolbarDescriptor.style.leftAxisCard,
              draggable: "true",
              onDragstart: ($event: any) => (_ctx.onDragStart($event, row, 'left-' + row.name)),
              onDragend: ($event: any) => (_ctx.removeDragClass('left-' + row.name))
            }, [
              (row.hierarchies.length > 1)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "fas fa-sitemap",
                    class: "p-button-text p-button-rounded p-button-plain",
                    style: _ctx.toolbarDescriptor.style.whiteColor,
                    onClick: ($event: any) => (_ctx.$emit('showMultiHierarchy', row))
                  }, null, 8, ["style", "onClick"]))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode("div", {
                class: ["olap-rotate-text kn-flex kn-truncated", { 'p-mt-2': row.hierarchies.length == 1 }],
                flex: ""
              }, [
                _createTextVNode(_toDisplayString(_ctx.cutName(row.caption, 0, row.hierarchies.length > 1)), 1)
              ], 2), [
                [
                  _directive_tooltip,
                  row.caption,
                  void 0,
                  { right: true }
                ]
              ]),
              _createVNode("div", {
                id: "whitespace",
                class: "p-mt-auto",
                style: _ctx.toolbarDescriptor.style.whitespaceLeft
              }, null, 4),
              _createVNode(_component_Button, {
                icon: "fas fa-filter",
                class: "p-button-text p-button-rounded p-button-plain p-mt-auto p-m-0",
                style: _ctx.toolbarDescriptor.style.whiteColor,
                onClick: ($event: any) => (_ctx.openFilterDialog(row))
              }, null, 8, ["style", "onClick"])
            ], 44, ["id", "onDragstart", "onDragend"]),
            (row.positionInAxis < _ctx.rows.length - 1)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "fas fa-arrows-alt-v p-my-2",
                  style: {"cursor":"pointer"},
                  onClick: ($event: any) => (_ctx.$emit('switchPosition', row))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createVNode("div", {
          ref: "axisDropzone",
          class: "kn-flex kn-truncated olap-rotate-text p-my-1",
          style: _ctx.toolbarDescriptor.style.leftAxisDropzone
        }, _toDisplayString(_ctx.$t('documentExecution.olap.filterToolbar.drop')), 5)
      ], 36),
      (_ctx.showScroll)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            icon: "fas fa-arrow-circle-down",
            class: "p-button-text p-button-rounded p-button-plain p-mt-1",
            style: _ctx.toolbarDescriptor.style.whiteColor,
            onClick: _ctx.scrollDown
          }, null, 8, ["style", "onClick"]))
        : _createCommentVNode("", true)
    ], 36)
  ], 4))
})